/**
 * Centralised query-key prefixes used by react-query hooks and when
 * invalidating caches.  Keeping them in one place avoids typo-caused
 * cache misses and makes it easy to search for all usages.
 */
export const QUERY_KEYS = {
  consumablesPage: "consumables-page",
  consumableFromParam: "consumable-from-param",
  consumablesLowStock: "consumables-low-stock",
  modelsLowStock: "models-low-stock",
  locationAssetsPage: "location-assets-page",
  statusLabels: "status-labels",
  dashboardModelCount: "dashboard-model-count",
  locationDetail: "location-detail",
} as const;
